import { Modal, Button } from 'react-bootstrap'
import { StyledButtonContainer, StyledConfirmModal } from './FinalAckModal.styled'
import { useGlobalStore } from 'store/useGlobalStore'

interface IProps {
  show: boolean
  onClose: any
  events: {
    setShowModal: any
    handleAcknowledgedConfirm: any
  }
}

export const FinalAckModal = ({ show, onClose, events }: IProps) => {
  const [assetFolder] = useGlobalStore((state) => [state.userClaims.CurrentBuyerTypeAssetFolder])

  return (
    <StyledConfirmModal show={show} backdrop="static" centered>
      <Modal.Body>
        <div className="modal-header">
          <label className="modal-title">Are you sure you want to buy this vehicle?</label>
          <div className="modal-final-sale">
            <img src="/content/img/warningred.png" alt="" />
            <label>All sales are final</label>
          </div>
        </div>

        <StyledButtonContainer assetFolder={assetFolder}>
          <Button className="btn-popup btn-neglect" onClick={() => onClose()}>
            No, Take me back to the Vehicle Grounding page
          </Button>
          <Button onClick={events.handleAcknowledgedConfirm} className="btn-popup btn-confirm">
            Yes, I confirm I want to buy this vehicle
          </Button>
        </StyledButtonContainer>
      </Modal.Body>
    </StyledConfirmModal>
  )
}
export default FinalAckModal
